import * as React from 'react';
import { Card, Form } from "react-bootstrap";
import './BeneficiaryDetailForm.css';

interface BeneficiaryDetailFormProps {
    beneficiary: {
        name: string;
        percentage: string;
        personalRelation: string;
        rsaIdNumber: string;
        dateOfBirth: string;
        email: string;
        phoneNumber: string;
    },
    emitHandleUpdate,
    title: string,
    subtitle: string,
    beneficiaryForm: any,
    emitHandleChange: any,
}

export class BeneficiaryDetailForm extends React.Component<BeneficiaryDetailFormProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
        }
        
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    
    handleUpdate() {
        this.props.emitHandleUpdate();
    }
    
    handleChange(e) {
        const val = e.target.value;
        const key = e.target.name;
        
        this.props.emitHandleChange(key, val);
    }

    public render() {
        const beneficiaryForm = this.props.beneficiaryForm;

        return <div className="beneficiary-detail-form">
            <Card>
                <Card.Title className="pb-0 pl-4 pt-4">
                    <h3 className="mb-0 update-beneficiaries__title">{ this.props.title }</h3>
                </Card.Title>
                <Card.Subtitle className="pb-0 pl-4">
                    <p>{ this.props.subtitle }</p>
                </Card.Subtitle>
                <hr />
                <Card.Body className="beneficiary-detail__card-body">
                    <div className="pb-0 pl-4 row">
                          { Object.keys(beneficiaryForm).map((key) => 
                              <div className={'form-group col-12' + (!beneficiaryForm[key] ? ' has-error' : '')}>
                                  <Form.Label className={'left-align' + (beneficiaryForm[key] !== "" ? "" : " no-opacity")}>{ beneficiaryForm[key].label }</Form.Label>
                                  { beneficiaryForm[key]?.as ? <Form.Control
                                    as={beneficiaryForm[key].as}
                                    type={beneficiaryForm[key].type}
                                    placeholder=""
                                    id={`beneficiary-detail-form-${key}`} 
                                    name={key}
                                    value={beneficiaryForm[key].value}
                                    onChange={this.handleChange}>
                                    <option></option>
                                    { beneficiaryForm[key].options?.length > 0 && beneficiaryForm[key].options.map((option) => 
                                        <option value={option.value}>
                                            { option.name }
                                        </option> )}
                                        
                                  </Form.Control>
                                  : <Form.Control
                                    type={beneficiaryForm[key].type}
                                    placeholder=""
                                    id={`beneficiary-detail-form-${key}`} 
                                    name={key}
                                    value={beneficiaryForm[key].value} 
                                    onChange={this.handleChange} />
                                  }
                              </div> )}
                      </div>
                      <hr />
                      <div className="row justify-content-end">
                          <div>
                              <button onClick={this.handleUpdate} className="btn beneficiary-detail__update-button mr-3">
                                  <img className="arrow" src={"/my-policy/Images/Claims/Edit-pen.png"} />
                                  Save
                              </button>
                          </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    }
}